import { useTranslation } from "react-i18next";

import useGetColours from "@/helpers/getColours";
import { noDp } from "@/helpers/helpers";
import useAppStore from "@/store/appStateZustand";
import { useUIStateStore } from "@/store/uiStateStore";

function TabWriters({ result }) {
  const currencySymbol = useAppStore(s => s.tenantCurrencySymbol);
  const { t } = useTranslation("other");
  const total = result?.body?.aggregations?.WriterPaymentSum?.value || 0;
  const highestWriter = result?.body?.aggregations?.Writers?.buckets?.[0]?.WriterName?.hits?.hits?.[0]?._source;
  const highestWriterTotal = result?.body?.aggregations?.Writers?.buckets?.[0]?.WriterValues?.value;
  const highestAccount = result?.body?.aggregations?.ArtistAccounts?.buckets?.[0]?.ArtistAccountName?.hits?.hits?.[0]?._source;
  const highestAccountTotal = result?.body?.aggregations?.ArtistAccounts?.buckets?.[0]?.WriterValues?.value;

  const { highlightColour2 } = useGetColours();

  const isTunecore = useUIStateStore(state => state.isTunecore);

  // if (pending || !result) {
  //   return (<LoadingSmall />);
  // }

  return (
    <div className="flex flex-col items-start h-full p-4">
      <h1 className={`text-md xl:text-xl font-medium ${isTunecore ? "text-white" : "text-black"} lg:mb-4`}>{t("other:writers-and-accounts-tab-header")}</h1>
      <div className="w-full font-sentric-alt">
        <div className="flex flex-row items-center justify-between w-full h-14 ">
          <div style={{ color: isTunecore ? "" : highlightColour2 }} className="text-xs font-semibold text-left uppercase">
            {t("other:total-writer")}
            <br />
            {t("other:earnings")}
            :
          </div>
          <div style={{ color: isTunecore ? "" : highlightColour2 }} className="text-base font-semibold text-left uppercase">
            {currencySymbol}
            {noDp(total)}
          </div>

        </div>

        <div className="flex flex-row items-center justify-between w-full h-14 ">
          <div style={{ color: isTunecore ? "" : highlightColour2 }} className="text-xs font-semibold text-left">
            {t("other:highest-earning-writer")}
          </div>
          <div className={`${isTunecore ? "text-white" : "text-ink-primary"} font-medium text-xs pl-1`}>
            <span>
              {highestWriter?.writerFirstName}
              {" "}
              {highestWriter?.writerMiddleName || ""}
              {" "}
              {highestWriter?.writerLastName}
              {" - "}
              {currencySymbol}
              {noDp(highestWriterTotal)}
            </span>
          </div>

        </div>

        <div className="flex flex-row items-center justify-between w-full h-14 ">
          <div style={{ color: isTunecore ? "" : highlightColour2 }} className="mr-2 text-xs font-semibold text-left uppercase">
            {t("other:total-account")}
            <br />
            {t("other:earnings")}
            :
          </div>
          <div style={{ color: isTunecore ? "" : highlightColour2 }} className="text-base font-semibold text-left uppercase">
            {currencySymbol}
            {noDp(total)}
          </div>
        </div>

        <div className="flex flex-row items-center justify-between w-full h-14 ">
          <div style={{ color: isTunecore ? "" : highlightColour2 }} className="text-xs font-semibold text-left">
            {t("other:highest-earning-account")}
          </div>
          <div className={`${isTunecore ? "text-white" : "text-ink-primary"} font-medium text-xs pl-1`}>
            <span>
              {highestAccount?.artistAccountName}
              {" - "}
              {currencySymbol}
              {noDp(highestAccountTotal)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TabWriters;
